export default {
    url: '/per_feature',
    data: {
        title: 'Per Feature',
        role: 'video',
        priority: 801,
    },
    template: require('./view.html'),
    reloadOnSearch: false,
};
